import { getAnnotatedPerDayDatasetDetails } from "api/annotationData";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { userSelector } from "store/userSlice";
import { timestampToDate } from "utils/functions";

interface DatasetType {
  key: string;
  _id: string;
  imageName: string;
  datasetName: string;
  datasetDescription: string;
  cameraType_name: string;
  classifier: string;
  imagesCount: number;
  updatedAt: string;
  selectedClass: string;
  selectedSubClasses: any[];
  encodedImg: string;
  datasetId: string;
  classifierId: string;
  bucketId: string;
  imgId: string;
  identifier: string;
  imgKey: string;
}

export const AnnotationPerDayDatasetLogic = (datasetId: any) => {
  let dataKeyCount = 0;
  const datasetTableInfo: DatasetType[] = [];
  const userInfo = useSelector(userSelector);

  const [totalAnnotationCount, setTotalAnnotationCount] = useState<number>(0);
  const [, setSearchTerm] = useState<string>("");
  const [searched, setSearched] = useState<boolean>(false);
  const [datasets, setDatasets] = useState<{
    loading: boolean;
    error: boolean;
    data: any[];
  }>({
    loading: false,
    error: false,
    data: [],
  });
  const [pageCount, setPageCount] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);

  const today = new Date();
  const dateTerm = `${today.getFullYear()}-${
    today.getMonth() <= 8 ? "0" + (today.getMonth() + 1) : today.getMonth() + 1
  }-${today.getDate() <= 8 ? "0" + today.getDate() : today.getDate()}`;

  // const datasetId = "";

  /** Fetch datasets depending on pageCOunt, limit & searched */
  useEffect(() => {
    setDatasets({
      loading: true,
      error: false,
      data: [],
    });
    try {
      const fetchDatasets = async () => {
        const res = await getAnnotatedPerDayDatasetDetails({
          pageCount,
          pageLimit,
          dateTerm,
          datasetId,
        });
        setTotalAnnotationCount(res.count);
        setDatasets({
          loading: false,
          error: false,
          data: res.annotations,
        });
      };
      fetchDatasets();
    } catch (error) {
      setDatasets({
        loading: false,
        error: true,
        data: [],
      });
    }
  }, [pageCount, pageLimit, dateTerm, datasetId]);

  /** Putting datasets in the interface form for ease of showing in table */
  function addDatasetsInTable() {
    datasets.data.length &&
      datasets.data.forEach((eachDataset: any) => {
        datasetTableInfo.push({
          key: dataKeyCount.toString(),
          imageName: eachDataset.image?.metadata.filename,
          _id: eachDataset.dataset_id._id,
          datasetName: eachDataset.dataset_id.name,
          datasetDescription: eachDataset.dataset_id.description,
          cameraType_name: eachDataset.dataset_id.cameraType_name,
          classifier: eachDataset?.classifier_id?.pathology,
          imagesCount: eachDataset.imagesCount,
          updatedAt: timestampToDate(eachDataset.updatedAt),
          selectedClass: eachDataset?.class?.name,
          selectedSubClasses: eachDataset?.subclasses,
          encodedImg: eachDataset.encodedImg,
          datasetId: eachDataset.dataset_id._id,
          classifierId: eachDataset.classifier_id._id,
          bucketId: eachDataset.class._id,
          imgId: eachDataset.image._id,
          identifier: eachDataset.dataset_id.identifier,
          imgKey: eachDataset.image.key,
        });
        dataKeyCount += 1;
      });
  }
  addDatasetsInTable();

  return {
    userInfo,
    datasets,
    setSearchTerm,
    datasetTableInfo,
    pageCount,
    setPageCount,
    pageLimit,
    setPageLimit,
    totalAnnotationCount,
    searched,
    setSearched,
  };
};
